/*
 *
 * ReportsPage reducer
 *
 */

import { fromJS } from "immutable"
import { validate } from "../../../utils/functions"
import { KEY_ISOLATED_METRICS, setItem } from "../../../utils/storage"
import {
  GET_STATUS_WATCHER,
  GET_STATUS_SUCCESS,
  GET_STATUS_FAILED,
  GET_MEASURE_COLOR_RANGE_WATCHER,
  GET_MEASURE_COLOR_RANGE_SUCCESS,
  GET_MEASURE_COLOR_RANGE_FAILED,
  GET_MEASURE_TOTAL_WATCHER,
  GET_MEASURE_TOTAL_SUCCESS,
  GET_MEASURE_TOTAL_FAILED,
  GET_MEASURE_GENERAL_FAILED,
  GET_MEASURE_GENERAL_SUCCESS,
  GET_MEASURE_GENERAL_WATCHER,
  SAVE_CONFIG_BENCHMARK_WATCHER,
  SAVE_CONFIG_BENCHMARK_SUCCESS,
  SAVE_CONFIG_BENCHMARK_FAILED,
} from "./constants"

export const initialState = fromJS({
  isLoading: false,
  no_process: false,
  measureColorRange: [],
  isMeasureProcess: false,
  dimensionsBottom: [],
  dimensionsTop: [],
  divisionsAvailable: [],
  divisionsData: {},
  measureGeneral: null,
  measureTotal: null,
  measureConfig: null,
  isLoadingTotal: false,
  isLoadingSaveConfig: false,
  isSectorDataAvailable: false,
  companySectors: [],
  companySectorsGlobal: [],
  companySector: null,
  userType: null,
})

function reportAdminReducer(state = initialState, action) {
  switch (action.type) {
    case GET_STATUS_WATCHER:
      setItem(KEY_ISOLATED_METRICS, false)
      return state
        .set("isLoading", true)
        .set("isMeasureProcess", false)
        .set("dimensionsBottom", [])
        .set("dimensionsTop", [])
        .set("divisionsAvailable", [])
        .set("measureGeneral", null)
        .set("measureTotal", null)
        .set("divisionsData", {})
        .set("measureConfig", null)
        .set("userType", null)
        .set("isSectorDataAvailable", false)
    case GET_STATUS_SUCCESS:
      setItem(
        KEY_ISOLATED_METRICS,
        action.payload.measureGeneral.has_isolated_metrics || false
      )
      return state
        .set("isLoading", false)
        .set(
          "isMeasureProcess",
          !!(action.payload.measureTotal && action.payload.measureTotal.percent)
        )
        .set("dimensionsBottom", action.payload.dimensions_bottom)
        .set("dimensionsTop", action.payload.dimensions_top)
        .set("divisionsAvailable", action.payload.divisionsAvailable)
        .set("divisionsData", action.payload.divisionsData)
        .set("measureTotal", action.payload.measureTotal)
        .set("measureGeneral", action.payload.measureGeneral)
        .set("isErrorStatus", false)
        .set("userType", action.payload.userType)
        .set("measureConfig", action.payload.measureConfig)
        .set("isSectorDataAvailable", action.payload.isSectorDataAvailable)
        .set("companySectors", action.payload.companySectors)
        .set("companySectorsGlobal", action.payload.companySectorsGlobal)
        .set("companySector", action.payload.companySector)
    case GET_STATUS_FAILED:
      return state
        .set("isLoading", false)
        .set("isMeasureProcess", false)
        .set("dimensionsBottom", [])
        .set("dimensionsTop", [])
        .set("divisionsAvailable", [])
        .set("divisionsData", {})
        .set("isolatedMetrics", false)
        .set("measureGeneral", null)
        .set("measureTotal", null)
        .set("measureConfig", null)
        .set("userType", null)
        .set("isErrorStatus", true)
        .set("isSectorDataAvailable", false)

    case GET_MEASURE_COLOR_RANGE_WATCHER:
      return state.set("measureColorRange", [])
    case GET_MEASURE_COLOR_RANGE_SUCCESS:
      return state.set(
        "measureColorRange",
        validate.exist(action.payload.report_color_range)
          ? action.payload.report_color_range
          : []
      )
    case GET_MEASURE_COLOR_RANGE_FAILED:
      return state.set("measureColorRange", [])
    case GET_MEASURE_GENERAL_WATCHER:
      return state.set("isLoading", true).set("measureGeneral", null)
    case GET_MEASURE_GENERAL_SUCCESS:
      return state.set("isLoading", false).set("measureGeneral", action.payload)
    case GET_MEASURE_GENERAL_FAILED:
      return state.set("isLoading", false).set("measureGeneral", null)
    case GET_MEASURE_TOTAL_WATCHER:
      return state.set("measureTotal", null).set("isLoadingTotal", true)
    case GET_MEASURE_TOTAL_SUCCESS:
      return state
        .set("measureTotal", action.payload)
        .set("isLoadingTotal", false)
    case GET_MEASURE_TOTAL_FAILED:
      return state.set("measureTotal", null).set("isLoadingTotal", false)

    case SAVE_CONFIG_BENCHMARK_WATCHER:
      return state.set("isLoadingSaveConfig", true)
    case SAVE_CONFIG_BENCHMARK_SUCCESS:
      return state.set("isLoadingSaveConfig", false)
    case SAVE_CONFIG_BENCHMARK_FAILED:
      return state.set("isLoadingSaveConfig", false)

    default:
      return state
  }
}

export default reportAdminReducer
